// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__S3HAC","pulse":"skeleton_pulse__BE_MM"};